/**
 * FILE: NavItem.js
 * PURPOSE: A "Menu Button."
 * WHAT IT DOES: It's a small reusable button used in the sidebar to move between different screens like "Feed" or "Saved."
 * LAYMAN SUMMARY: A simple building block for the app's navigation menu.
 */
import React from 'react';
import { Lock } from 'lucide-react';
import { haptics } from '../utils/haptics';

export function NavItem({ icon, label, active, onClick, isPro, darkMode, isLocked }) {
  return (
    <button
      onClick={(e) => {
        if (!isLocked) {
          haptics.impact();
          onClick?.(e);
        }
      }}
      aria-disabled={isLocked ? 'true' : undefined}
      title={isLocked ? `Sign in to unlock ${label}` : label}
      className={`w-full flex items-center gap-4 p-4 rounded-2xl font-bold transition-all border-l-4 group ${active
        ? 'bg-primary-600/10 text-primary-600 border-primary-600 shadow-sm'
        : (darkMode ? 'text-gray-500 hover:bg-gray-800 border-transparent hover:text-gray-200' : 'text-gray-500 hover:bg-gray-50 border-transparent hover:text-gray-900')
        } ${isLocked ? 'opacity-60 grayscale-[0.5] cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <div className={`flex-shrink-0 w-6 h-6 flex items-center justify-center transition-transform group-hover:scale-110 ${active ? 'text-primary-600' : (isLocked ? 'text-gray-500' : 'text-gray-500')}`}>
        {React.cloneElement(isLocked ? <Lock /> : icon, { size: 20 })}
      </div>
      <span className="flex-1 text-left text-sm tracking-tight">{label}</span>
      {(isPro || isLocked) && !active && <Lock size={14} className="text-gray-300 opacity-50 flex-shrink-0" aria-hidden="true" />}
    </button>
  );
}